import { HomeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { ReactElement } from 'react';

import classes from './NotFound.module.css';

export default function NotFound(): ReactElement {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.errorCode}>404</div>
        <h1 className={classes.title}>Page Not Found</h1>
        <p className={classes.description}>The page you're looking for doesn't exist or has been moved.</p>
        <Button size="large" href="/orgs" icon={<HomeOutlined />} className={classes.button}>
          Back to Home
        </Button>
      </div>
    </div>
  );
}
